import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgExpand = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", height: 24, viewBox: "0 0 24 24", width: 24, role: "img", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" }),
  /* @__PURE__ */ jsx("path", { d: "M0 0h24v24H0z", fill: "none" })
] });
const ForwardRef = forwardRef(SvgExpand);
export default ForwardRef;
